import { render, staticRenderFns } from "./mutiEllipsis.vue?vue&type=template&id=dc9594b8&"
import script from "./mutiEllipsis.vue?vue&type=script&lang=js&"
export * from "./mutiEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/mutiEllipsis.vue"
export default component.exports